export const PushCampaignAPI = {
  campaign: {
    list: '/push_campaigns',
    detail: '/push_campaigns/:id',
    create: '/push_campaigns',
    cancel: '/push_campaigns/:id/cancel',
    schedule: '/push_campaigns/:id/schedule',
  }
}
